import { useEffect } from "react";
import { platform } from "./react";
import { previewingExample } from "./ExamplePreview";
import { SITE_PLUGIN, sitePlugin } from "../../platform/site";

const KEPT = "truechops.site", CHANGED = "truechops:site";
// The site as its owner set it up (src/platform/site.js): the last settings seen, at once, then the
// current ones. Previewing an example shows another site altogether, so these stay out of it.
export function applySite(settings) {
  if (previewingExample()) return;
  platform().remove(SITE_PLUGIN).use(sitePlugin(settings));
}
// After the owner saves.
export const siteChanged = (settings) => window.dispatchEvent(new CustomEvent(CHANGED, { detail: settings }));

export default function SiteSettings() {
  useEffect(() => {
    const keep = (settings) => { applySite(settings); try { localStorage.setItem(KEPT, JSON.stringify(settings)); } catch { /* Too big, or no storage: it comes from the server next time. */ } };
    try { const saved = JSON.parse(localStorage.getItem(KEPT) || "null"); if (saved) applySite(saved); } catch { /* Nothing kept. */ }
    fetch("/api/platform/site").then((response) => response.ok ? response.json() : null).then((data) => { if (data?.site) keep(data.site); }).catch(() => {});
    const changed = (event) => keep(event.detail);
    window.addEventListener(CHANGED, changed);
    return () => window.removeEventListener(CHANGED, changed);
  }, []);
  return null;
}
